import type { Products } from '@forest/native-services'

class Loading<T = void> {
  public promise: Promise<T>
  public done: (value: T) => void = () => {}

  constructor() {
    this.promise = new Promise<T>((resolve) => {
      this.done = resolve
    })
  }
}

export const productsReady = new Loading<Products>()
